import { render, staticRenderFns } from "./Tariffs.vue?vue&type=template&id=ac9ffe88"
import script from "./Tariffs.vue?vue&type=script&lang=js"
export * from "./Tariffs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports